import React from 'react';
import { RESTAURANT_INFO } from '../../utils/constants';

export interface MapProps {
  address?: string;
  height?: string;
  className?: string;
}

/**
 * Map Component — uses OpenStreetMap (free, no API key needed)
 * Coordinates: 53.6293 N, 9.9515 E (Tibarg 16, Hamburg)
 */
export const Map: React.FC<MapProps> = ({
  address = RESTAURANT_INFO.address,
  height = '400px',
  className = '',
}) => {
  const { lat, lng } = RESTAURANT_INFO.coordinates;

  // OpenStreetMap embed URL — completely free, no API key
  const osmEmbedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${lng - 0.005}%2C${lat - 0.003}%2C${lng + 0.005}%2C${lat + 0.003}&layer=mapnik&marker=${lat}%2C${lng}`;

  // Google Maps directions link (still free — just opens in browser)
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <div
        className="relative rounded-lg overflow-hidden border border-[#c9a84c]/20"
        style={{ height }}
      >
        <iframe
          src={osmEmbedUrl}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          title={`Karte: ${address}`}
          aria-label={`OpenStreetMap Karte für ${address}`}
        />
      </div>

      {/* Link to open in Google Maps for directions */}
      <a
        href={directionsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-gray-500 hover:text-[#c9a84c] transition-colors text-center"
        aria-label="In Google Maps öffnen"
      >
        In Google Maps öffnen →
      </a>
    </div>
  );
};
